import { SET_USER_LOADING, SET_USER_DATA, RESET_USER_DATA, SET_USER_SIGNING } from "../../../actions/userActions";

export const user = ( state = {}, action) => {
    switch(action.type) {
        case SET_USER_LOADING: {
            const { loading } = action.payload;
            return {...state, loading }
        }

        case SET_USER_SIGNING: {
            return {...state, isSigning: true }
        }

        case SET_USER_DATA: {
            const { data, role, displayName, permissions } = action.payload
            return {...state, data, role, displayName, permissions, isSign: true, isSigning: false }
        }

        case RESET_USER_DATA: {
            return { data: {}, role: '', displayName: '', permissions: null, isSign: false }
        }

        default:
            return state
    }
}
